import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { Provider } from 'react-redux';
import store from './services/store';
import { IntlProvider } from 'react-intl';
import messages from './translations/pl';

import '../node_modules/noty/lib/noty.css';
import '../node_modules/noty/lib/themes/mint.css';

const domNode = document.getElementById("root");
const root = createRoot(domNode);

root.render(
  <Provider store={store}>
    <IntlProvider locale="pl" messages={messages}>
      <App />
    </IntlProvider>
  </Provider>
);
